
import {
  computed, defineComponent, onBeforeUnmount, onMounted, PropType, ref,
} from 'vue'
import axios from 'axios'
import { Webinar, WebinarSchedule } from '@/types/webinar.d'
import AdminButtons from '@/vue/public/AdminButtons.vue'
import IconArrowAlt from '@/vue/icons/IconArrowAlt.vue'
import IconReload from '@/vue/icons/IconReload.vue'
import { useI18n } from 'vue-i18n'
import YouTubeVideo from '@/vue/public/YouTubeVideo.vue'
import { useStore } from '@/vue/store'
import Buttons from './Buttons.vue'
import Chat from './Chat.vue'

declare global {
  interface Window {
    BASE_URI: string
    footerText: {
      left: string
      right: string
    }
    webinarsLogo: string
  }
}

export default defineComponent({
  name: 'Webinar',
  props: {
    webinar: {
      type: Object as PropType<Webinar>,
      required: true,
    },
    schedule: {
      type: Object as PropType<WebinarSchedule>,
      required: true,
    },
    archived: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    YouTubeVideo,
    IconReload,
    Buttons,
    Chat,
    AdminButtons,
    IconArrowAlt,
  },
  setup(props) {
    const { t } = useI18n()
    const store = useStore()

    const administration = computed(() => store.state.userAdmin
      && !props.schedule.endAt && !props.archived)

    const loadingFinishing = ref(false)
    const utm = computed(() => store.state.userUtm)
    const fullscreen = ref(false)

    function onContextMenu(e: MouseEvent) {
      if (!store.state.userAdmin) {
        e.preventDefault()
      }
    }

    onMounted(() => document.addEventListener('contextmenu', onContextMenu))
    onBeforeUnmount(() => document.removeEventListener('contextmenu', onContextMenu))

    return {
      mainPage: window.BASE_URI,
      logo: window.webinarsLogo,
      footer: window.footerText,
      baseURI: window.BASE_URI,

      t,
      administration,
      loadingFinishing,
      fullscreen,

      changeFullscreen(value: boolean) {
        fullscreen.value = value
      },
      async finishTranslation() {
        // eslint-disable-next-line no-alert
        if (store.state.userAdmin && !props.schedule.endAt && !loadingFinishing.value && confirm(t('public.confirmFinish'))) {
          loadingFinishing.value = true
          await axios.post(`/webinars/${props.schedule.id}/finish`)
        }
      },
      reload() {
        document.location.reload()
      },
      addUtm(href: string) {
        let l: string = href
        if (utm.value) {
          l += l.includes('?') ? '&' : '?'
          l += utm.value.replace(/^\?/, '')
        }
        return l
      },
    }
  },
})
